import { isBoolean } from 'lodash'
import { getIdOrNull, validateString } from '..'
import { ValidationFields } from '../validators'

export const ACT_TYPE_VALIDATORS = [
  { key: ValidationFields.NAME, validator: s => validateString(s.name, { notEmpty: true }) },
  { key: ValidationFields.TYPE, validator: s => isBoolean(s.hoursFormat) }
]

export const ACT_TYPES = {
  false: 'common.numerical',
  true: 'common.schedules'
}

export const getName = a => {
  return a.name
}

export const getCategory = a => {
  return a.actTypeCategory?.name ?? null
}

export const getType = a => {
  return a.hoursFormat
}

export const actType = Object.freeze({
  getFullName: a => {
    return a.section && a.section.name ? `${a.section.name} | ${a.name}` : `${a.name}`
  },
  getFullAcronym: a => {
    return a.section && a.section.abbreviation ? `${a.section.abbreviation} - ${a.acronym}` : `${a.acronym}`
  }
})

export class ActType {
  constructor ({ id = -1, actTypeCategory = null, hoursFormat = false, name = '', school = null } = {}) {
    this.id = id
    this.actTypeCategory = actTypeCategory
    this.hoursFormat = hoursFormat
    this.name = name
    this.school = school
  }

  toRequestBody = () => {
    const body = { ...this }

    body.actTypeCategory = getIdOrNull(this.actTypeCategory)
    body.school = getIdOrNull(this.school)

    return body
  }
}
